module.exports = __webpack_public_path__ + "app/modals/broadcast-message-warning-modal.view.html";